export default __webpack_public_path__ + "static/media/webhooks.c3511f47.png";